import React, { useState } from 'react';
import styled from 'styled-components/macro';

import { Icons, NotesModal, colors } from '@united-talent-agency/components';
import { CALL_ROW } from '../../../support/cypressTags';
import EllipsisText from '../EllipsisText';
import { useEffect } from 'react';

const Notes = ({ notes, onSave, canEdit = true }) => {
  const [displayNote, setDisplayNote] = useState(notes?.[0]?.note);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setDisplayNote(notes?.[0]?.note);
  }, [notes]);

  const handleSaveNotes = (updatedNotes) => {
    // Ensure all notes have the required 'note' property (GraphQL schema requirement)
    const sanitizedNotes = updatedNotes?.map((noteObj) => ({
      ...noteObj,
      note: noteObj.note || '',
    }));

    setDisplayNote(sanitizedNotes?.[0]?.note);
    if (JSON.stringify(sanitizedNotes) !== JSON.stringify(notes)) {
      onSave({ notes: sanitizedNotes });
    }
  };

  const toggleModal = (bool) => {
    setIsOpen(bool);
  };

  return (
    <TableCell
      onClick={() => {
        if (!isOpen) {
          toggleModal(true);
        }
      }}
    >
      <Container>
        {!!displayNote && <Icons.NoteIcon style={{ minWidth: 12, minHeight: 12, marginTop: 3 }} />}
        <NoteTextContainer
          data-cy={CALL_ROW.NOTES}
          style={{ whiteSpace: 'normal', maxWidth: '100%' }}
        >
          <EllipsisText
            text={displayNote}
            style={{
              display: '-webkit-box',
              WebkitLineClamp: '2',
              WebkitBoxOrient: 'vertical',
              whiteSpace: 'normal',
            }}
          />
        </NoteTextContainer>
        {isOpen && (
          <NotesModal
            notes={notes}
            onSave={handleSaveNotes}
            handleCloseModal={() => toggleModal(false)}
            cypressTag={CALL_ROW.NOTES_INPUT}
            canEdit={canEdit}
          />
        )}
      </Container>
    </TableCell>
  );
};

const TableCell = styled.td({
  position: 'relative',
  borderLeft: `1px solid ${colors.whiteSmoke}`,

  '&&': {
    paddingLeft: '8px',
    paddingRight: '8px',
  },
});

const Container = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  maxWidth: '100%',
});

const NoteTextContainer = styled.span({
  maxWidth: '350px',
  minWidth: '150px',
  float: 'left',
  paddingLeft: '5px',
  lineHeight: '1.5em',
  height: '3em',
  maxHeight: '3em',
});

export default Notes;
